import { Component } from '@angular/core';

@Component({
  selector: 'app-deactivate-icon',
  templateUrl: './deactivate-icon.component.html',
  styleUrls: ['./deactivate-icon.component.scss']
})
export class DeactivateIconComponent {

}
